import { createContext } from '@chakra-ui/react-utils';
import { UseDropdownReturn } from './useDropdown';

export const [DropdownProvider, useDropdownContext] =
  createContext<UseDropdownReturn>({
    name: 'DropdownContext',
  });
